import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			display: 'flex',
			flexDirection: 'row',
			marginBottom: 16,
			'& > .MuiFormControl-root': {
				display: 'flex',
				flex: 1,
			},
		},
		select: {
			height: 36,
		},
		selectItemSpan: {
			width: '100%',
		},
	})
